<template>
  <section v-if="getShowBillingCampaign" class="wrapper-campaign">
    <header>
        <h1>Campanha de Discagem Cobrança</h1>
    </header>

    <div v-if="validateClients" class="wrapper-clients-info">
      <div v-if="showCurrentClient" :class="['client-info', 'current-client', showCurrentClient.redial && 'redial-client']">
        <h1>Cliente Atual</h1>
        <span><b>Name: </b> {{ showCurrentClient.client_name }}</span>
        <span><b>Telefone: </b>{{ showCurrentClient.client_phone }}</span>
        <span><b>CPF/CNPJ: </b>{{ formatCpfCnpj(showCurrentClient.client_id) }}</span>
        <span><b>Vencimento: </b>{{ formatDate(showCurrentClient.client_expiration) }}</span>
        <span><b>Valor: </b>{{ formatCurrency(showCurrentClient.client_value) }}</span>
        <span v-if="showCurrentClient.tab">
          <b>Tabulação: </b>{{ convertTabOption(showCurrentClient.tab) }}
        </span>
        <span v-if="showCurrentClient.tab">
          <b>Descrição: </b>{{ showCurrentClient.tab_obs }}
        </span>

        <div class="wrapper-dial-now">
          <button class="btn btn-primary" @click="dialCurrentClient">
            <span>Discar para {{ showCurrentClient.client_name }}</span>
            <i class="fas fa-phone"></i>
          </button>
        </div>
      </div>

      <div v-if="showNextClient" :class="['client-info', 'next-client', showNextClient.redial && 'redial-client']">
        <h1>Próximo Cliente</h1>
        <span><b>Name: </b> {{ showNextClient.client_name }}</span>
        <span><b>Telefone: </b>{{ showNextClient.client_phone }}</span>
        <span><b>CPF/CNPJ: </b>{{ formatCpfCnpj(showNextClient.client_id) }}</span>
        <span><b>Vencimento: </b>{{ formatDate(showNextClient.client_expiration) }}</span>
        <span><b>Valor: </b>{{ formatCurrency(showNextClient.client_value) }}</span>
        <span v-if="showNextClient.tab">
          <b>Tabulação: </b>{{ convertTabOption(showNextClient.tab) }}
        </span>
        <span v-if="showNextClient.tab">
          <b>Descrição: </b>{{ showNextClient.tab_obs }}
        </span>
      </div>

      <div v-else class="client-info no-clientes">
        <h3>Sem Próximo Cliente</h3>
        <i class="fas fa-ban"></i>
      </div>
    </div>

    <div v-else class="wrapper-no-clients">
      <h1>Sem Clientes</h1>
      <i class="fas fa-ban"></i>
    </div>

    <hr>

    <div v-if="validateClients" class="wrapper-timer">
      <section>
        <div class="clock-wrap">
          <div class="clock pro-0">
            <span class="count">{{ count }}</span>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
const socketAMI = io.connect(`${location.protocol}//${location.hostname}:3006/`);
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "BillingDialCampaign",
  data() {
    return {
      campaignTimer: 10,
      campaignClients: [],
      countdown: true,
      tabOptions: [],
      timeBetweenCampaigns: false,
      interval: null,
      half: 0,
      barColor: "#00b4d8",
      backColor: "#feeff4",
      count: 0,
      inCall: false
    };
  },
  methods: {
    ...mapActions([
      "setCallData",
    ]),
    dialCurrentClient() {
      if (this.inCall) return;
      if (this.validateClients) {
        const clientPhone = this.formatPhoneToCall(this.campaignClients[0].client_phone);
        socketAMI.emit('OriginateTab', {
            calltype: 'outgoing',
            extension: user.getExtension(),
            phone: `0${clientPhone}`
        });
      }
    },
    async startFromHangup() {
      this.inCall = false;
      await this.updateClient(this.campaignClients[0], this.getCallData);
      this.callNextClients();
      // this.startRestTime();
      this.startCountdown();
    },
    getClients() {
      axios.get("/generateBillingCampaign")
      .then(({ data }) => {
        this.campaignClients = data;
      });
    },
    getTabOptions() {
      axios.get("/listTabOptions")
      .then(({ data }) => {
        this.tabOptions = data;
      });
    },
    async updateClient(client, callData) {
      const recalCase = {
        5: true,
        9: true,
        12: true,
        13: true,
      }

      client.call_id = callData.call_id || null;
      client.tab = callData.tab || null;
      client.tab_obs = callData.tab_obs || null;
      client.redial = client.redial ? false : recalCase[callData.tab] || false;
      return await axios.put("updateBillingCampaign", client)
      .then(() => {
        this.setCallData({
          call_id: null,
          tab: null,
          tab_obs: null,
        });
      });
    },
    listeningCalls() {
      socketAMI.on(`CoreShowChannel-${user.getExtension()}`, () => {
        this.clearCountdown();
        this.inCall = true;
      });

      socketAMI.on(`NewConnectedLine-${user.getExtension()}`, () => {
        this.clearCountdown();
        this.inCall = true;
      });
    },
    listeningHangupRinging() {
      socketAMI.on(`HangupRinging-${user.getExtension()}`,
      async () => {
        const callData = {
          call_id: null,
          tab: 5,
          tab_obs: "Discagem recusada pelo operador",
        };

        this.inCall = false;
        await this.updateClient(this.campaignClients[0], callData);
        this.callNextClients();
        this.startCountdown();
      })
    },
    formatCurrency(value) {
        if (!value) return "R$ 0,00";
        return Number(value.replace("R$", "")).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
    formatDate(date) {
        if (!date) return "Sem Data";
        const formatted = new Date(date);
        return formatted.toLocaleDateString();
    },
    formatPhoneToCall(phone) {
        let newPhone = phone.replace(/\D/g, "");
        newPhone = newPhone.slice(0, 2) == "55" ? newPhone.slice(2) : newPhone;
        return newPhone;
    },
    formatCpfCnpj(value) {
      const cnpjCpf = value?.replace(/\D/g, '');
      if (cnpjCpf?.length === 11) {
        return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4");
      }

      return cnpjCpf?.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5");
    },
    convertTabOption(option) {
      return this.tabOptions[option] || "";
    },
    callNextClients() {
      const amountClients = this.campaignClients.length;
      if (amountClients >= 2) {
        this.getClients();
      } else {
        if (amountClients > 0) {
          this.campaignClients.shift();
        }
      }
    },
    startCountdown() {
      this.clearCountdown();
      let pie = 0;
      let num = 0;
      let sec = 15;
      let lop = sec;
      this.count = sec;
      $(".count").addClass("sec");

      this.interval = setInterval(() => {
        sec = sec - 1;
        pie = pie + 100 / lop;

        if (pie >= 101) {
          pie = 1;
        }

        num = (sec / 60).toFixed(2).slice(0, -3);
        if (num == 0) {
          $(".count").removeClass("min").addClass("sec");
          this.count = sec;
        } else {
          $(".count").removeClass("sec").addClass("min");
          this.count = num;
        }

        let indx = pie.toFixed(2).slice(0, -3) - 1;
        if (indx < this.half) {
          let nextdeg = 90 + this.increment * indx + "deg";
          $(".clock").css({
            "background-image":
              "linear-gradient(90deg," +
              this.backColor +
              " 50%,transparent 50%,transparent),linear-gradient(" +
              nextdeg +
              "," +
              this.barColor +
              " 50%," +
              this.backColor +
              " 50%," +
              this.backColor +
              ")",
          });
        } else {
          let nextdeg = -90 + this.increment * (indx - this.half) + "deg";
          $(".clock").css({
            "background-image":
              "linear-gradient(" +
              nextdeg +
              "," +
              this.barColor +
              " 50%,transparent 50%,transparent),linear-gradient(270deg," +
              this.barColor +
              " 50%," +
              this.backColor +
              " 50%," +
              this.backColor +
              ")",
          });
        }

        if (sec == 0) {
          this.stopCountdown();
        }
      }, 1000);
    },
    startRestTime() {
      this.clearCountdown();
      let pie = 0;
      let num = 0;
      let sec = 5;
      let lop = sec;
      this.count = sec;
      $(".count").addClass("sec");

      this.interval = setInterval(() => {
        sec = sec - 1;
        pie = pie + 100 / lop;

        if (pie >= 101) {
          pie = 1;
        }

        num = (sec / 60).toFixed(2).slice(0, -3);
        if (num == 0) {
          $(".count").removeClass("min").addClass("sec");
          this.count = sec;
        } else {
          $(".count").removeClass("sec").addClass("min");
          this.count = num;
        }

        let indx = pie.toFixed(2).slice(0, -3) - 1;
        if (indx < this.half) {
          let nextdeg = 90 + this.increment * indx + "deg";
          $(".clock").css({
            "background-image":
              "linear-gradient(90deg," +
              this.backColor +
              " 50%,transparent 50%,transparent),linear-gradient(" +
              nextdeg +
              "," +
              this.barColor +
              " 50%," +
              this.backColor +
              " 50%," +
              this.backColor +
              ")",
          });
        } else {
          let nextdeg = -90 + this.increment * (indx - this.half) + "deg";
          $(".clock").css({
            "background-image":
              "linear-gradient(" +
              nextdeg +
              "," +
              this.barColor +
              " 50%,transparent 50%,transparent),linear-gradient(270deg," +
              this.barColor +
              " 50%," +
              this.backColor +
              " 50%," +
              this.backColor +
              ")",
          });
        }

        if (sec == 0) {
          this.startCountdown();
        }
      }, 1000);
    },
    stopCountdown() {
      this.clearCountdown();
      this.dialCurrentClient();
      this.countdown = false;
    },
    clearCountdown() {
      clearInterval(this.interval);
      this.count = 0;
      $(".clock").removeAttr("style");
    },
  },
  beforeMount() {
    this.getClients();
    this.getTabOptions();
  },
  mounted() {
    this.getClients();
    this.listeningHangupRinging();
    this.listeningCalls();

    const step = 1;
    const loops = Math.round(100 / step);
    this.increment = 360 / loops;
    this.half = Math.round(loops / 2);
    this.barColor = "#00b4d8";
    this.backColor = "#feeff4";

    if (this.getShowBillingCampaign && !this.inCall) {
      this.startCountdown();
    }
  },
  beforeDestroy() {
    this.clearCountdown();
  },
  computed: {
    ...mapGetters([
      "getShowBillingCampaign",
      "getStartCampaign",
      "getCallData",
    ]),
    validateClients() {
      return this.campaignClients.length > 0;
    },
    showCurrentClient() {
      return this.campaignClients[0] || false;
    },
    showNextClient() {
      return this.campaignClients[1] || false;
    },
  },
  watch: {
    getStartCampaign() {
      this.startFromHangup();
    },
    getShowBillingCampaign() {
      if (this.getShowBillingCampaign && !this.inCall) {
        this.startCountdown();
      }
    }
  },
};
</script>

<style scoped>
.wrapper-campaign {
  padding: 10px;
  border: 1px solid #c2c2c2;
  border-radius: 10px;
  margin: 20px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
}

.wrapper-campaign header {
    height: 100px;
    margin-bottom: 20px;
    border-radius: 10px 10px 0px 0px;
    background: rgb(28,134,154);
    background: linear-gradient(180deg, rgba(28,134,154,1) 0%, rgba(255,255,255,1) 100%);
}

.wrapper-campaign h1 {
    text-align: center;
}

.wrapper-campaign header > h1 {
    font-size: 3rem;
    color: #fff;
}

.wrapper-clients-info {
  display: flex;
  justify-content: space-around;
}

.wrapper-no-clients {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrapper-no-clients i {
    font-size: 60px;
    color: red;
}

.client-info {
  display: flex;
  flex-direction: column;
  padding: 0px 20px;
  font-size: 1.5rem;
}

.current-client {
  width: 55%;
  border-right: solid 1px #cccccc;
}

.next-client {
  width: 45%;
  border-left: solid 1px #cccccc;
}

.redial-client {
  background: #ffeba1;
  background: linear-gradient(90deg, #ffeba1 0%, rgba(255,255,255,1) 90%);
}

.no-clientes {
    width: 40%;
    align-items: center;
    justify-content: space-evenly;
}

.no-clientes i {
    font-size: 60px;
    color: red;
}

.wrapper-timer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wrapper-dial-now {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 5px;
}

.wrapper-dial-now button {
  border-radius: 8px !important;
}








.clearfix:after,
.clearfix:before {
  content: "";
  display: table;
}

.clearfix:after {
  clear: both;
  display: block;
}

.clock:before,
.count:after {
  content: "";
  position: absolute;
}

.clock-wrap {
  margin: auto;
  width: 225px;
  height: 225px;
  margin: 25px 0px;
  position: relative;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15);
}

.clock {
  top: 50%;
  left: 50%;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  position: absolute;
  margin-top: -90px;
  margin-left: -90px;
  background-color: #feeff4;
}

.clock:before {
  top: 50%;
  left: 50%;
  width: 120px;
  height: 120px;
  margin-top: -60px;
  margin-left: -60px;
  border-radius: inherit;
  background-color: #00b4d8;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15),
    0 0 3px rgba(255, 255, 255, 0.75) inset;
  /*border:1px solid rgba(255,255,255,.1);*/
}

.count {
  width: 100%;
  color: #fff;
  height: 100%;
  padding: 50px;
  font-size: 32px;
  font-weight: 500;
  line-height: 50px;
  position: absolute;
  text-align: center;
}

.count:after {
  width: 100%;
  display: block;
  font-size: 18px;
  font-weight: 300;
  line-height: 18px;
  text-align: center;
  position: relative;
}

.count.sec:after {
  content: "sec";
}

.count.min:after {
  content: "min";
}

.action {
  margin: auto;
  max-width: 200px;
}

.action .input {
  margin-top: 30px;
  position: relative;
}

.action .input-num {
  width: 100%;
  border: none;
  padding: 12px;
  border-radius: 60px;
}

.action .input-btn {
  top: 0;
  right: 0;
  color: #fff;
  border: none;
  border: none;
  padding: 12px;
  position: absolute;
  border-radius: 60px;
  background-color: #00b4d8;
  text-transform: uppercase;
}

.tbl {
  display: table;
  width: 100%;
}

.tbl .col {
  display: table-cell;
}
</style>